<template>
  <div class="order-wrapper">
    <portal target-el="#filter">
      <Breadcrumb @onChangeMonth="search" :walletList="walletList" @exportWallet='exportWallet'/>
    </portal>
    <div>
      <Header />
      <div class="fixed-row"
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="loadCheck"
        infinite-scroll-throttle-delay="400"
        infinite-scroll-distance="10">
        <div v-if="isTransporterListLoading && walletList.length === 0">
          Loading
        </div>
        <div v-else-if="walletList.length === 0" class="no-order-data">No Data Found</div>
        <div v-else>
          <Row v-for="wallet in walletList" :key="wallet.transporter_id" :wallet="wallet" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from './header';
import Row from './row';
import Breadcrumb from './breadcrumb';
import { mapGetters } from 'vuex';

export default {
  components: {
    Breadcrumb,
    Header,
    Row,
  },
  data() {
    return {
      month: new Date().getMonth() + 1,
      year: new Date().getFullYear(),
      loadCheck: true,
    };
  },
  computed: {
    ...mapGetters({
      isTransporterListLoading: 'wallet/isTransporterListLoading',
      walletList: 'wallet/transporterWallet',
      page: 'wallet/page',
      hasEmpty: 'wallet/hasEmpty',
    }),
  },

  async created() {
    this.$store.commit('wallet/initData');
    this.search();
  },

  methods: {
    search(params) {
      this.$store.commit('wallet/SET_PAGE',1);
      this.loadMore(params);
    },
    async loadMore(params) {
      if (params) {
        this.month = params.month;
        this.year = params.year;
      }
      const result = await this.$store.dispatch('wallet/listForTransporters',
        { month: this.month, year: this.year, page: this.page });
      if (result.error) {
        this.$errorMessage({ message: result.error });
      }
      this.loadCheck = this.hasEmpty;
    },
    async exportWallet() {
      const params = { month: this.month, year: this.year };
      this.$store.dispatch('wallet/exportWallet', params);
    },
  },
};
</script>
<style lang='scss'>
.fixed-row {
  position: fixed;
  padding-right: 10px;
  top: 170px;
  left: 20px;
  right: 10px;
  bottom: 0;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
